<template>
    <chart :options="opt" />
</template>

<script>

  import ECharts from "vue-echarts";
  import "echarts/lib/chart/bar";
  import "echarts/lib/chart/scatter";
  import "echarts/lib/component/markLine";
  import "echarts/lib/component/markArea";
  import "echarts/lib/component/tooltip";
  import "echarts/lib/component/graphic";

  export default {
    name: "a3",
    props: {},
    components: { chart: ECharts },
    data() {
      var data = {
        axis: {
          xAxis: "绩效",
          yAxis: "薪资"
        },
        /*peopleNum: [
  {
    //人数
    num: 2,
    //薪资
    salary: 36,
    //职级
    rank: 3,
    //绩效
    merits: 2
  },
  {
    num: 235,
    salary: 26.5,
    rank: 3,
    merits: 2
  },
  {
    num: 23,
    salary: 20.6,
    rank: 3,
    merits: 2
  },
  {
    num: 8,
    salary: 31.2,
    rank: 3,
    merits: 2
  },
  {
    num: 36,
    salary: 25.4,
    rank: 3,
    merits: 2
  },
  {
    num: 373,
    salary: 38.5,
    rank: 3,
    merits: 2
  },
  {
    num: 642,
    salary: 29.0,
    rank: 3,
    merits: 2
  },
  {
    num: 264,
    salary: 22.2,
    rank: 3,
    merits: 2
  },
  {
    num: 4363,
    salary: 21.4,
    rank: 3,
    merits: 2
  },
  {
    num: 34,
    salary: 22.4,
    rank: 3,
    merits: 2
  },
  {
    num: 46,
    salary: 13.7,
    rank: 3,
    merits: 2
  },
  {
    num: 844,
    salary: 24.6,
    rank: 3,
    merits: 2
  },
  {
    num: 34,
    salary: 19.6,
    rank: 3,
    merits: 2
  },
  {
    num: 674,
    salary: 24.9,
    rank: 3,
    merits: 2
  },
  {
    num: 45,
    salary: 25.8,
    rank: 3,
    merits: 2
  },
  {
    num: 47,
    salary: 16.6,
    rank: 3,
    merits: 2
  },
  {
    num: 457,
    salary: 21.5,
    rank: 3,
    merits: 2
  },
  {
    num: 43,
    salary: 20.5,
    rank: 3,
    merits: 2
  },
  {
    num: 345,
    salary: 36.8,
    rank: 3,
    merits: 2
  },
  {
    num: 63,
    salary: 26.0,
    rank: 3,
    merits: 2
  },
  {
    num: 64,
    salary: 27.6,
    rank: 3,
    merits: 2
  },
  {
    num: 63,
    salary: 23.0,
    rank: 3,
    merits: 2
  },
]*/
        provinces: [
          {
            name: "0",
            rate: 23.7,
            ratio: 26,
            value: 7.2
          },
          {
            name: "1",
            rate: 26.5,
            ratio: 29.4,
            value: 7.4
          },
          {
            name: "2",
            rate: 20.6,
            ratio: 23.8,
            value: 6.9
          },
          {
            name: "j",
            rate: 31.2,
            ratio: 38.9,
            value: 16.9
          },
          {
            name: "g",
            rate: 25.4,
            ratio: 34.8,
            value: 16.3
          },
          {
            name: "m",
            rate: 38.5,
            ratio: 43.4,
            value: 16.2
          },
          {
            name: "nm",
            rate: 29.0,
            ratio: 38.5,
            value: 15.5
          },
          {
            name: "b",
            rate: 22.2,
            ratio: 27.6,
            value: 11.0
          },
          {
            name: "v",
            rate: 21.4,
            ratio: 24.6,
            value: 10.4
          },
          {
            name: "c",
            rate: 22.4,
            ratio: 28.9,
            value: 10.3
          },
          {
            name: "x",
            rate: 13.7,
            ratio: 21.2,
            value: 10.1
          },
          {
            name: "l",
            rate: 24.6,
            ratio: 24.7,
            value: 9.6
          },
          {
            name: "k",
            rate: 19.6,
            ratio: 25.7,
            value: 9.4
          },
          {
            name: "j",
            rate: 24.9,
            ratio: 27.9,
            value: 9.4
          },
          {
            name: "h",
            rate: 25.8,
            ratio: 30.1,
            value: 9.2
          },
          {
            name: "g",
            rate: 16.6,
            ratio: 21.9,
            value: 8.7
          },
          {
            name: "s",
            rate: 21.5,
            ratio: 26.0,
            value: 8.5
          },
          {
            name: "g",
            rate: 20.5,
            ratio: 25.7,
            value: 8.4
          },
          {
            name: "d",
            rate: 36.8,
            ratio: 37.1,
            value: 8.3
          },
          {
            name: "f",
            rate: 26.0,
            ratio: 27.8,
            value: 7.6
          },
          {
            name: "h",
            rate: 27.6,
            ratio: 30.1,
            value: 7.3
          },
          {
            name: "h",
            rate: 23.0,
            ratio: 26.7,
            value: 7.0
          },
        ]
      };

      //  取最值
      var minRate = 0,
        maxRate = 0,
        minRatio = 0,
        maxRatio = 0;
      data.provinces.forEach((province, index) => {
        if(province.rate !== "-" && province.ratio !== "-" && province.value !== "-") {
          if(index > 0) {
            //  rate最值
            if(parseFloat(province.rate) < minRate) {
              minRate = province.rate;
            } else if(parseFloat(province.rate) > maxRate) {
              maxRate = province.rate;
            }
            //  ratio最值
            if(parseFloat(province.ratio) < minRatio) {
              minRatio = province.ratio;
            } else if(parseFloat(province.ratio) > maxRatio) {
              maxRatio = province.ratio;
            }
          } else {
            minRate = maxRate = province.rate;
            minRatio = maxRatio = province.ratio;
          }
        }
      });

      // 各个轴上的间隔
      var xInterval = (maxRate - minRate) / 5;
      var yInterval = (maxRatio - minRatio) / 5;

      // 背景的25个区域
      var markAreaData = [];
      for(let i = 0; i < 5; i++) {
        var tmp = [];
        for(let j = 0; j < 5; j++) {
          tmp = [
            {
              // name: `x${i + 1}-y${j + 1}`,
              itemStyle: {
                color: `#33${i}${i}${j}${j}`
              },
              coord: [minRate + xInterval * i, minRatio + yInterval * j]
            },
            {
              coord: [minRate + xInterval * (i + 1), minRatio + yInterval * (j + 1)]
            }
          ];
          markAreaData.push(tmp);
        }
      }

      // 散点的数据
      var seriesData = [];
      data.provinces.map(item => {
        if(item.rate !== "-" && item.ratio !== "-" && item.value !== "-") {
          /*let symbolSize = 0;
        if(Math.abs(item.value) < 1) {
           symbolSize = Math.abs(item.value) * 10;
         } else if(Math.abs(item.value) < 50) {
           symbolSize = Math.abs(item.value);
         } else {
           symbolSize = Math.abs(item.value) / 2;
         }*/
          seriesData.push({
            name: item.name,
            value: [item.rate, item.ratio, item.value],
            symbolSize: item.value
          });
        }
      });

      return {
        opt: {
          title: {
            text: "",
            show: false
          },
          grid: {
            left: "3%",
            right: "10%",
            bottom: "3%",
            containLabel: true
          },
          legend: {
            selectedMode: false,
            data: ["城市业绩"],
            left: "center"
          },
          tooltip: {
            trigger: "item",
            showDelay: 0,
            axisPointer: {
              show: true,
              type: "cross",
              lineStyle: {
                type: "dashed",
                width: 1
              },
            },
            formatter: function(obj) {
              if(obj.componentType == "series") {
                return `
                    <div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">${obj.name} </div>
                    <div>${data.axis.xAxis}：${obj.data.value[0]}%</div>
                    <div>${data.axis.yAxis}：${obj.data.value[1]}万</div>
                    <div>值：${obj.data.value[2]}</div>
                 `;
              }
            }
          },
          xAxis: {
            name: data.axis.xAxis,
            type: "value",
            zlevel: 3,
            scale: true,
            nameGap: -70,
            axisLabel: {
              formatter: "{value} %"
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false,
              symbol: ["none", "arrow"]
            },
            min: Math.floor(minRate), // math.floor() 向下取整
            max: Math.ceil(maxRatio)  //  math.ceil() 向上取整
            // min: Math.floor(minValue / 5) * 6, // math.floor() 向下取整
            // max: Math.ceil(maxValue / 5) * 6 //  math.ceil() 向上取整
          },
          yAxis: {
            name: data.axis.yAxis,
            type: "value",
            scale: true,
            zlevel: 3,
            axisLabel: {
              // formatter: "{value}"
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false,
              symbol: ["none", "arrow"]
            },
            min: Math.floor(minRatio), // math.floor() 向下取整
            max: Math.ceil(maxRatio)  //  math.ceil() 向上取整
            // min: Math.floor(minValue / 5) * 6, // math.floor() 向下取整
            // max: Math.ceil(maxValue / 5) * 6 //  math.ceil() 向上取整
          },
          series: [
            {
              name: "气泡大小",
              type: "scatter",
              data: seriesData,
              zlevel: 2,
              label: {
                show: true,
                color: "#000",
                formatter: function(param) {
                  return param.name;
                },
                position: "inside"
              },
              itemStyle: {
                normal: {
                  shadowBlur: 10,
                  shadowColor: "rgba(120, 36, 50, 0.5)",
                  shadowOffsetY: 5,
                  color: new ECharts.graphic.RadialGradient(0.4, 0.3, 1, [{
                    offset: 0,
                    color: "rgb(170, 207, 223)"
                  }, {
                    offset: 1,
                    color: "rgb(171, 204, 222)"
                  }])
                }
              },
              markArea: {
                zlevel: 0,
                silent: true,
                data: markAreaData
              }
            }
          ]
        }
      };
    }
  };
</script>
<style scoped>

</style>
